
import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { addActionEnvoieFailure, addActionEnvoieStart, addActionEnvoieSuccess, getActionsEnvoisFailure, getActionsEnvoisStart, getActionsEnvoisSuccess, updateActionEnvoieFailure, updateActionEnvoieStart, updateActionEnvoieSuccess } from "./ActionEnvoieAction";


const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getActionsEnvois = async(dispatch, pageSize, page, id, typeActionEnvoieId, agenceId, transporteurId, livreurId, dateEnvoie, paiement)=>{
    let filter = {id, type:typeActionEnvoieId, agence:agenceId, transporteur:transporteurId, livreur:livreurId, dateEnvoie, paiement };
    dispatch(getActionsEnvoisStart());
    try{
        const res = await axiosInstance.post(`/admin/actions?pageSize=${pageSize}&page=${page}`,filter,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getActionsEnvoisSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(getActionsEnvoisFailure(err.response.data.message))
        }else{
            dispatch(getActionsEnvoisFailure("Unkown Error"))
        }
    }
}

export const addActionEnvoie = async(dispatch, typeId, agenceId, deliveryId, description)=>{
    let actionBody = {type:typeId, agence:agenceId, delivery:deliveryId, description};
    dispatch( addActionEnvoieStart())
    try{
        const res = await axiosInstance.post(`/admin/actions/add`,actionBody,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch( addActionEnvoieSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch( addActionEnvoieFailure(err.response.data.message))
        }else{
            dispatch( addActionEnvoieFailure("Unkown Error"))
        }
    }
}

export const updateActionEnvoie = async(dispatch, id, typeId, agenceId, deliveryId, description)=>{
    let actionBody = {type:typeId, agence:agenceId, delivery:deliveryId, description};
    dispatch(updateActionEnvoieStart())
    try{
        const res = await axiosInstance.put(`/admin/actions/update/${id}`,actionBody,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(updateActionEnvoieSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(updateActionEnvoieFailure(err.response.data.message))
        }else{
            dispatch(updateActionEnvoieFailure("Unkown Error"))
        }
    }
}

